export const GET_FILE_LOGS = 'GET_FILE_LOGS'
export const GET_FOLDER_LOGS = 'GET_FOLDER_LOGS'
export const GET_ROOM_LOGS = 'GET_ROOM_LOGS'
export const GET_LOGS_TYPES = 'GET_LOGS_TYPES'
